function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.541 0c7.5 0 13.636 6.136 13.636 13.636v21.137c0 1.909-1.5 3.409-3.41 3.409H3.587c-1.91 0-3.41-1.5-3.41-3.41V3.41C.177 1.5 1.677 0 3.587 0h12.954Zm-1.364 2.727H3.587c-.41 0-.683.273-.683.682v31.364c0 .409.273.682.682.682h23.182c.41 0 .682-.273.682-.682V15c0-1.5-1.228-2.727-2.728-2.727h-5.454c-.75 0-1.364-.614-1.364-1.364V5.455c0-1.5-1.227-2.728-2.727-2.728Zm5.045.683c.273.614.41 1.296.41 2.046v4.09h4.09c.682 0 1.432.137 2.046.41a10.739 10.739 0 0 1-6.546 0V3.41Z",
  fill: "currentColor",
  fillRule: "nonzero"
});

function SvgDocumentOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 39,
    viewBox: "0 0 31 39",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentOutline);
export default __webpack_public_path__ + "static/media/documentOutline.860adcfc.svg";
export { ForwardRef as ReactComponent };